import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import Breadcrumbs from "../../../../ui/Breadcrumbs";
import {makeStyles} from "@material-ui/core/styles";
import useQuizSessionList from "./useQuizSessionList";
import Box from "../../../../ui/Box";
import SquareButton from "../../../../ui/SquareButton";
import CachedIcon from "@material-ui/icons/Cached";
import SearchField from "../../../../ui/SearchField";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import DataGrid, {
  Column,
  Export,
  FilterRow,
  LoadPanel,
  Scrolling,
  Selection
} from "devextreme-react/data-grid";
import { columns } from "./utils";
import InfoDrawer from "../../../../ui/InfoDrawer";
import AnswersDrawer from "../../components/AnswersDrawer";

const items = [
  {
    label: "Опросы",
    link: "/work/app/quiz"
  },
  {
    label: "Участие в опросах",
    link: "#"
  },
];

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "row",
    "& #gridContainer": {
      height: "calc(100vh - 200px)"
    }
  },
  controls: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "16px",
    "& > div": {
      display: "flex",
      alignItems: "flex-end",
      "& > *:not(:nth-last-child(1))": {
        marginRight: "14px"
      }
    }
  },
  secondaryMenu: {
    "& ul": {
      padding: 0
    },
    "& > .MuiPaper-root": {
      top: "170px !important"
    },
    padding: 0
  },
  menuItem: {
    fontSize: "12px",
    padding: "17px"
  },
});

const dataGridElementAttrs = {
  id: "gridContainer"
};

const QuizSessionList = () => {
  const [focusedQuiz, setFocusedQuiz] = useState("");
  const {root, controls, secondaryMenu, menuItem} = useStyles();
  const {load, data} = useQuizSessionList();
  const dataGridRef = useRef(null);
  const [secondaryMenuAnchorEl, setSecondaryMenuAnchorEl] = React.useState(null);
  const secondaryMenuOpen = Boolean(secondaryMenuAnchorEl);

  const defaultSecondaryActions = useMemo(() => {
    return [
      {
        label: "Экспортировать выбранные",
        onClick: () => dataGridRef.current.instance.exportToExcel(true)
      },
      {
        label: "Экспортировать все",
        onClick: () => dataGridRef.current.instance.exportToExcel(false)
      },
      {
        label: "Выбор видимых столбцов",
        onClick: () => dataGridRef.current.instance.showColumnChooser()
      },
    ];
  }, [dataGridRef]);

  const searchByText = useCallback((e) => {
    const text = e.target.value;
    dataGridRef.current.instance.searchByText(text);
  }, [dataGridRef]);

  const handleSecondaryMenuClick = useCallback(event => {
    setSecondaryMenuAnchorEl(event.currentTarget);
  }, [setSecondaryMenuAnchorEl]);

  const handleSecondaryMenuClose = useCallback((action) => {
    setSecondaryMenuAnchorEl(null);
    typeof action === 'function' && action();
  }, [setSecondaryMenuAnchorEl]);

  useEffect(() => {
    load();
  }, []);

  const handleRefresh = useCallback(() => {
    load();
  }, []);

  const TableRowClick = useCallback((e) => {
    const focusedQuiz = e ? e.key : "";
    setFocusedQuiz(focusedQuiz);
  }, [setFocusedQuiz]);

  return <div>
    <Breadcrumbs items={items} />
    <div className={root}>
      <Box>
        <div className={controls}>
          <div>
            <SquareButton onClick={handleRefresh}>
              <CachedIcon fontSize="small"/>
            </SquareButton>
            <SearchField width={400} onChange={searchByText}/>
          </div>
          <div>
            <SquareButton onClick={handleSecondaryMenuClick}>
              <MoreVertIcon fontSize="small"/>
            </SquareButton>
            <Menu
              className={secondaryMenu}
              anchorEl={secondaryMenuAnchorEl}
              keepMounted
              open={secondaryMenuOpen}
              onClose={handleSecondaryMenuClose}
            >
              {defaultSecondaryActions.map(({label, onClick, disabled}) => (
                <MenuItem
                  key={label}
                  onClick={() => handleSecondaryMenuClose(onClick)}
                  className={menuItem}
                  disabled={disabled}
                >
                  {label}
                </MenuItem>
              ))}
            </Menu>
          </div>
        </div>
        <div>
          <DataGrid
            elementAttr={dataGridElementAttrs}
            ref={dataGridRef}
            wordWrapEnabled={true}
            dataSource={data}
            focusedRowEnabled
            errorRowEnabled={false}
            onRowClick={TableRowClick}
            keyExpr={"sessionGuid"}
            focusedRowKey={focusedQuiz}
            showBorders>
            <Selection
              mode="multiple"
              showCheckBoxesMode="onClick"
              showBorders={true}
              width={120}
            />
            {columns.map(column => (
              <Column key={column.dataField} {...column} />
            ))}

            <Export fileName={'Пройденные опросы'}/>
            <FilterRow visible={true}/>
            <Scrolling mode="virtual"/>
            <LoadPanel enabled/>
          </DataGrid>
        </div>
      </Box>
      <AnswersDrawer open={focusedQuiz !== ""} sessionGuid={focusedQuiz}/>
    </div>
  </div>
}

export default QuizSessionList;
